module.exports = __webpack_public_path__ + "img/credinord.c6b725d.png";